"use client";

import { setRecentProducts } from "action/utils/setRecentProducts";
import { getRecentlyViewedProductsApi } from "api/product/getRecentlyViewedProductsApi";
import HorizontalSeparator from "component/design-system/horizontal-separator/HorizontalSeparator";
import { RootState } from "interfaces/generics.type";
import { isProductPage } from "modules/product/product-helper";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import withErrorHandler from "../../design-system/withErrorHandler";
import ShowRecentViewed from "./ShowRecentViewed";

interface IProps {
  sideBarHandler: () => null;
  ignoreSku?: string,
  productPage?: boolean;
}

function ProductRecentlyViewed(props: IProps) {
  const {
    ignoreSku, sideBarHandler, productPage,
  } = props;
  const isLoadingSession = useSelector((state: RootState) => state.authenticationState.refreshStatus !== "complete");
  const dispatch = useDispatch();
  const { recentProducts = [], currentPageType } = useSelector((state: RootState) => state.utils);
  const [loadingData, setLoadingData] = useState(false);
  const { businessCustomer } = useSelector((store: RootState) => store.authenticationState);

  useEffect(() => {
    if (isLoadingSession) {
      return;
    }
    setLoadingData(true);
    // fetch recent products
    getRecentlyViewedProductsApi()
      .then(({ data }) => {
        setLoadingData(false);
        dispatch(setRecentProducts(data));
      })
      .catch((err) => {
        console.log(err);
      });
  }, [isLoadingSession, ignoreSku]);

  const remaingProducts = recentProducts.filter((product) => product.sku !== ignoreSku);

  if (isLoadingSession || (loadingData && remaingProducts.length === 0)) {
    return <Skeleton height={101} count={5} />;
  }

  // In case there's no recently viewed products, TODO
  if (remaingProducts?.length === 0) {
    return <div id="empty-div" />;
    // return "TODO Place holder, to avoid CLS"; // TODO NOTE THIS.
  }

  if (businessCustomer) {
    return null;
  }

  return (
    <>
      <ShowRecentViewed
        products={remaingProducts}
        sideBarHandler={sideBarHandler}
        productPage={productPage}
      />
      <HideIf show={isProductPage(currentPageType)}>
        <HorizontalSeparator className="m-t-30" />
      </HideIf>
    </>
  );
}

export default withErrorHandler(ProductRecentlyViewed);
